<template>
  <a-result status="404" title="找不到对应平台！">
    <template #subTitle>
      <div>请从对应采购交易平台，点击登陆重新跳转</div>
      <div>{{ times }}秒后将自动跳转至最后一次平台登录页（如有）</div>
    </template>
    <template #extra>
      <a-button type="primary" @click="goBackLastPlatform('click')">
        返回
      </a-button>
    </template>
  </a-result>
</template>

<script>
import { CURRENT_TENANT_ID } from "@/store/mutation-types";

export default {
  data() {
    return {
      times: 5,
    };
  },
  mounted() {
    this.countdown();
  },
  methods: {
    // 倒计时
    countdown() {
      if (this.times) {
        setTimeout(() => {
          this.times--;
          if (this.times) {
            this.countdown();
          } else {
            this.goBackLastPlatform();
          }
        }, 1000);
      }
    },
    goBackLastPlatform(type) {
      if (type === "click" && !this.$ls.get(CURRENT_TENANT_ID)) {
        this.$message.info(
          "无最后一次平台登录页信息，请从对应采购交易平台，点击登陆重新跳转"
        );
      }
      if (this.$ls.get(CURRENT_TENANT_ID)) {
        console.log(1);
        this.$router.push({
          name: "login",
          query: {
            tenantId: this.$ls.get(CURRENT_TENANT_ID),
          },
        });
      }
    },
  },
};
</script>

<style lang="less" scoped></style>
